import React from "react";
import { useHistory } from "react-router-dom";
import { Experience } from "types";
import { SecondaryButton } from "../Common/SecondaryButton";
import { ContentLayout } from "../Layout/ContentLayout";
import { ProductPhotoList } from "./ProductPhotoList";

export const ExperiencePhotoList = ({ experience }: { experience: Experience }) => {
    const history = useHistory();

    const handleCancel = () => {
        history.push(`/products/experiences`);
    };

    return (
        <ContentLayout isWide>
            <ContentLayout.Section
                title="Photos"
                description="You can add a maximum of 10 .jpg, .png and .webp images to each product with a maximum size of 5 MB. Suggested pixel dimensions 1024x768"
            >
                <ProductPhotoList product={experience} />
            </ContentLayout.Section>

            <ContentLayout.Footer preferenceSidebar>
                <SecondaryButton type="reset" onClick={handleCancel}>
                    Cancel
                </SecondaryButton>
            </ContentLayout.Footer>
        </ContentLayout>
    );
};
